<template>
  <div class="w-full overflow-hidden">
    <!-- <h1 class="font-semibold text-ellie-blue text-center py-16 lg:py-[5vw] container-1 text-4xl md:text-[1.111vw] big-screen:text-[5vw] uppercase whitespace-pre-line lg:whitespace-normal">{{ "Who We\nWork With" }}</h1> -->

    <div class="overflow-hidden whitespace-nowrap py-10" data-aos="fade-up">

      <div class="infinite-loop">
        <div v-for="client in ourClients" :key="client" class="client-card">
          <figure class="client-logo" :width="client.width" :height="client.height">
            <img :src="client.url" :alt="client.alt" :width="client.width" :height="client.height" class="grayscale hover:grayscale-0 transition-all duration-300 opacity-80">
          </figure>
        </div>
      </div>

      <div class="infinite-loop">
        <div v-for="client in ourClients" :key="client" class="client-card">
          <figure class="client-logo" :width="client.width" :height="client.height">
            <img :src="client.url" :alt="client.alt" :width="client.width" :height="client.height" class="grayscale hover:grayscale-0 transition-all duration-300 opacity-80">
          </figure>
        </div>
      </div>
    </div>

    <div class="overflow-hidden whitespace-nowrap py-10 lg:hidden" data-aos="fade-up">
      <div class="infinite-loop-reverse">
        <div v-for="client in ourClients" :key="client" class="client-card">
          <figure class="client-logo" :width="client.width" :height="client.height">
            <img :src="client.url" :alt="client.alt" :width="client.width" :height="client.height" class="grayscale hover:grayscale-0 transition-all duration-300 opacity-80">
          </figure>
        </div>
      </div>

      <div class="infinite-loop-reverse">
        <div v-for="client in ourClients" :key="client" class="client-card">
          <figure class="client-logo" :width="client.width" :height="client.height">
            <img :src="client.url" :alt="client.alt" :width="client.width" :height="client.height" class="grayscale hover:grayscale-0 transition-all duration-300 opacity-80">
          </figure>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
// const ourClients = [
//   '/logo-assets/allianz.png',
//   '/logo-assets/f1.png',
//   '/logo-assets/hsbc.png',
//   '/logo-assets/jdecaux.png',
//   '/logo-assets/kao.png',
//   '/logo-assets/lazada.png',
//   '/logo-assets/martell.png',
//   '/logo-assets/ministry.png',
//   '/logo-assets/nus.png',
//   '/logo-assets/pg.png',
//   '/logo-assets/resortworld.png',
//   '/logo-assets/sgx.png',
//   '/logo-assets/shimadzu.png',
//   '/logo-assets/simmons.png',
//   '/logo-assets/singapore-cancer-society.png',
//   '/logo-assets/singlife.png',
// ];

const ourClients = [
  {
    url: '/logo-assets/update/lazada-logo.webp',
    width: 200,
    height: 79,
    alt: 'Lazada'
  },
  {
    url: '/logo-assets/update/hsbc-logo.webp',
    width: 200,
    height: 79,
    alt: 'HSBC'
  },
  {
    url: '/logo-assets/update/f1-logo.png',
    width: 200,
    height: 79,
    alt: 'F1'
  },
  {
    url: '/logo-assets/update/ministry-logo.webp',
    width: 200,
    height: 79,
    alt: 'Ministry of Communications and Information'
  },
  {
    url: '/logo-assets/update/sgx-logo.webp',
    width: 200,
    height: 79,
    alt: 'Singapore Exchange'
  },
  {
    url: '/logo-assets/update/shimadzu-logo.webp',
    width: 200,
    height: 79,
    alt: 'Shimadzu'
  },
  {
    url: '/logo-assets/update/kao-logo.webp',
    width: 200,
    height: 79,
    alt: 'KAO'
  },
  {
    url: '/logo-assets/update/pg-logo.webp',
    width: 200,
    height: 79,
    alt: 'P&G'
  },
  {
    url: '/logo-assets/update/martell-logo.webp',
    width: 169,
    height: 134,
    alt: 'Martell'
  },
  {
    url: '/logo-assets/update/resortworld-logo.webp',
    width: 200,
    height: 79,
    alt: 'Resort World Sentosa Singapore'
  },
  {
    url: '/logo-assets/update/singlife-logo.webp',
    width: 200,
    height: 79,
    alt: 'Singlife'
  },
  {
    url: '/logo-assets/update/allianz-logo.png',
    width: 200,
    height: 79,
    alt: 'Allianz'
  },
  {
    url: '/logo-assets/update/nus-logo.webp',
    width: 200,
    height: 79,
    alt: 'National University of Singapore'
  },
  {
    url: '/logo-assets/update/jcdecaux-logo.webp',
    width: 200,
    height: 79,
    alt: 'JCDecaux'
  },
  {
    url: '/logo-assets/update/scs-logo.webp',
    width: 200,
    height: 79,
    alt: 'Singapore Cancer Society'
  },
  {
    url: '/logo-assets/update/simmons-logo.webp',
    width: 200,
    height: 79,
    alt: 'Simmons'
  },
];
</script>

<style lang="scss" scoped>
.infinite-loop{
  @apply inline-flex items-center pointer-events-none touch-none;
  animation: logomove 80s linear infinite;
}

.infinite-loop-reverse{
  @apply inline-flex items-center pointer-events-none touch-none;
  animation: logomove-reverse 80s linear infinite;
}

.client-card{
  @apply w-[60vw] sm:w-[40vw] lg:w-[17vw] inline-flex overflow-hidden;
}

.client-logo{
  @apply w-full h-full flex justify-center items-center overflow-clip touch-none select-none ;
}

@keyframes logomove {
  from {
      transform: translateX(0);
  }
  to {
      transform: translateX(-100%);
  }
}

@keyframes logomove-reverse {
  from {
      transform: translateX(-100%);
  }
  to {
      transform: translateX(0%);
  }
}
</style>
